import { DaySchedule, ISO_WEEKDAY_NAMES, WEEKDAY_NAMES } from "../core";
/**
 * Ready-to-render view-model for the restaurant hours widget. Open/closed "now"
 * is computed with the shared domain engine (WeeklySchedule + Holidays);
 * per-day display strings keep the server-formatted `hours` values to avoid
 * i18n drift between the Ruby and TS formatters.
 */
export class PRestaurantHours {
    constructor(parsed) {
        this.parsed = parsed;
    }
    get upcomingHolidays() {
        return this.parsed.upcomingHolidays;
    }
    hasDistinctOnlineHours() {
        const opening = this.parsed.channelDayHours.opening;
        const online = this.parsed.channelDayHours.online;
        return opening.some((hours, index) => hours !== online[index]);
    }
    channel(channel, now) {
        var _a, _b, _c, _d;
        const schedule = this.parsed.channels[channel];
        const { override, append } = this.parsed.holidays.at(now);
        const base = override !== null && override !== void 0 ? override : schedule.weeklySchedule.dayOfWeek(now.weekday);
        const overnight = (_a = schedule.overnightAppends[now.weekday]) !== null && _a !== void 0 ? _a : DaySchedule.Empty;
        const isActiveToday = base.includes(now);
        const isActiveViaSpillover = overnight.union(append).includes(now);
        const isOpenNow = isActiveToday || isActiveViaSpillover;
        const yesterday = now.sub(1, "days");
        const activeDate = isActiveToday || !isActiveViaSpillover ? now : yesterday;
        const activeIsoWeekday = activeDate.day;
        const dayHours = this.parsed.channelDayHours[channel];
        const todayHoliday = this.findHoliday(now);
        const activeHoliday = this.findHoliday(activeDate);
        const presentDayHours = activeHoliday !== null
            ? activeHoliday.hours
            : ((_b = dayHours[activeDate.dayIndex]) !== null && _b !== void 0 ? _b : "");
        return {
            isOpenNow,
            presentDayHours,
            activeIsoWeekday,
            days: this.dayRows(channel, activeIsoWeekday),
            holidayHoursString: (_c = todayHoliday === null || todayHoliday === void 0 ? void 0 : todayHoliday.hours) !== null && _c !== void 0 ? _c : "",
            holidayInfo: (_d = todayHoliday === null || todayHoliday === void 0 ? void 0 : todayHoliday.info) !== null && _d !== void 0 ? _d : "",
        };
    }
    dayRows(channel, activeIsoWeekday) {
        const dayHours = this.parsed.channelDayHours[channel];
        return ISO_WEEKDAY_NAMES.map((weekday, isoIndex) => {
            var _a;
            const arrayIndex = WEEKDAY_NAMES.indexOf(weekday);
            const isoWeekday = isoIndex + 1;
            return {
                isoWeekday,
                hours: (_a = dayHours[arrayIndex]) !== null && _a !== void 0 ? _a : "",
                isActiveDay: isoWeekday === activeIsoWeekday,
            };
        });
    }
    findHoliday(date) {
        var _a;
        return ((_a = this.parsed.holidayViews.find((holiday) => holiday.dates.includes(date))) !== null && _a !== void 0 ? _a : null);
    }
}
